import { createSlice } from '@reduxjs/toolkit';
// import sum from 'lodash/sum';
// import uniqBy from 'lodash/uniqBy';
import { startOfDay, endOfDay, setHours } from 'date-fns';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
const newDetail = {
  checklist: null,
  location: null,
};

const initialState = {
  isLoading: false,
  error: null,
  title: '',
  desc: '',
  startDate: startOfDay(new Date()),
  endDate: startOfDay(new Date()),
  startTime: setHours(startOfDay(new Date()), 6),
  endTime: endOfDay(new Date()),
  repeat: {
    type: 'None',
    data: [],
  },
  details: [newDetail],
  assign: {},
  notification: true,
  active: true,
  activeStep: 0,
};

const slice = createSlice({
  name: 'schedule',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // END LOADING
    endLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    clearSchedule(state) {
      Object.assign(state, initialState);
    },
    getSchedureSuccess(state, action) {
      state = Object.assign(state, action.payload);
    },
    getChecklistsSuccess(state, action) {
      state.checklists = action.payload;
    },
    getLocationsSuccess(state, action) {
      state.locations = action.payload;
    },
    setValues(state, action) {
      Object.assign(state, action.payload);
    },
    setRepeat(state, action) {
      state.repeat = { ...state.repeat, ...action.payload };
    },
    setDetails(state, action) {
      state.details[action.payload.id] = { ...state.details[action.payload.id], ...action.payload.data };
    },
    addNewDetails(state) {
      state.details.push(newDetail);
    },
    removeDetails(state, action) {
      console.log(`removeDetails`, action.payload);
      state.details.splice(action.payload, 1);
    },
    setAssignUser(state, action) {
      state.assign = { ...state.assign, ...{ [action.payload.day]: action.payload.users } };
    },
    removeAssignUser(state, action) {
      console.log(`remove`, action.payload);
      const newAssignUser = state.assign[action.payload.day].filter((u) => u.id !== action.payload.user.id);
      state.assign = { ...state.assign, ...{ [action.payload.day]: newAssignUser } };
    },
    clearAssignUsers(state) {
      state.assign = {};
    },

    // STEPPER
    onBackStep(state) {
      state.activeStep -= 1;
    },
    onNextStep(state) {
      state.activeStep += 1;
    },
    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  clearSchedule,
  setValues,
  setRepeat,
  getSchedureSuccess,
  setDetails,
  addNewDetails,
  removeDetails,
  setAssignUser,
  removeAssignUser,
  clearAssignUsers,
  // getUsersSuccess,
  onBackStep,
  onNextStep,
  onGotoStep,
  // loading
  startLoading,
  endLoading,
} = slice.actions;

// ----------------------------------------------------------------------

// export function getSchedure() {
//   return async () => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const response = await axios.get('/schedules');
//       dispatch(slice.actions.getUsersSuccess(response.data));
//     } catch (error) {
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }

export function getChecklists() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/checklists');
      dispatch(slice.actions.getChecklistsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLocations() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/locations');
      dispatch(slice.actions.getLocationsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// // ----------------------------------------------------------------------

// export function getUser(id) {
//   return async () => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const response = await axios.get(`/users/${id}`);
//       dispatch(slice.actions.getUserSuccess(response.data));
//     } catch (error) {
//       console.error(error);
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }
